import React from 'react';
import TopicActionButton from '../../../Topic/TopicActionButton';

import {ProfileThumb} from '../../../Common/CardComponents';
import { makeRoute } from '../../../../helpers';
import cx from '../../../../styles';

const TopicList = ({topics, appReducer, match}) => {
    
    return (
        <div className={cx("topic-related-list-component")}>
            {
                topics.filter(topic => topic.total_questions > 0).map((topic, i) => {
                    return (
                        <section key={i} className={cx("post-section")}>
                            <div className={cx("post-section-header")}>
                                <div className={cx("left")}>
                                    <ProfileThumb img={topic.image ? topic.image : ""} size="large" altName={`${topic.name} icon`} />

                                    <div className={cx("author-name")}>
                                        <div><a href={makeRoute(`/topic/${topic.slug}`,appReducer)}>{topic.name}</a></div>
                                        <p>{topic.total_members} following</p>
                                    </div>
                                </div>

                                <div className={cx("right")}>
                                    <TopicActionButton topic={topic} shouldRefreshTopicList={false} buttonType={"plus"} match={match}/>
                                </div>
                            </div>
                        </section>
                    )
                })
            }
        </div>
    );
}

export default TopicList;
